module.exports = __webpack_public_path__ + "static/media/Roboto-MediumItalic.ebbeb79e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-MediumItalic.ttf
// module id = 524
// module chunks = 0